<template>
  <div class="create-credit-card-modal-redsys">
    <v-dialog
      :class="'rounded-t-xl'"
      transition="dialog-bottom-transition"
      :value="true"
      :maxWidth="800"
      width="100%"
      :height="700"
      :style="`backgroundColor:${colors.colorSurface} !important`"
      persistent
      @click:outside="closeDialog"
    >
      <template>
        <v-card class="border-0">
          <v-toolbar
            color="colors.colorPrimary"
            elevation="0"
            style="border-bottom: 1px solid #e0e0e0"
          >
            <v-toolbar-title :style="`color: black`">{{
              $t("mobile.payments.realizePayment")
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeDialog">
              <v-icon color="black">close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text :style="'padding: 0 !important'">
            <iframe
              v-if="payments_url"
              :src="payments_url"
              title="Flit2go Payments"
              width="100%"
              :height="700"
              class="overflow-y-hidden z-10 relative"
            >
            </iframe>
          </v-card-text>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
  name: "flit2go-payments",
  props: {
    client: {
      type: String,
      required: false,
    },
    amount: {
      type: Number,
      required: false,
    },
    concept: {
      type: String,
      default: null,
    },
    // Owner cuya pasarela debe usarse (p.ej. el owner de la categoría
    // seleccionada cuando el owner del frame es un agrupador). Si no se
    // informa, se usa el owner de la categoría seleccionada y, en su
    // defecto, el owner del frame.
    ownerIdProp: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      payments_url: undefined,
      eventListener: undefined,
    };
  },
  async mounted() {
    await this.setPaymentsUrl();
    this.setEventListener();
  },

  beforeDestroy() {
    this.removeEventListener();
  },

  computed: {
    ...mapState(["configuration"]),
    ...mapGetters({
      colors: "configuration/getColors",
      loginParameters: "user/loginParameters",
      userLoged: "user/userLoged",
      owner: "configuration/getOwner",
      redsysConfiguration: "configuration/getRedsysConfiguration",
      categorySelected: "category/categorySelected",
    }),
    ownerId() {
      if (this.ownerIdProp) {
        return this.ownerIdProp;
      }
      if (this.categorySelected && this.categorySelected.ownerId) {
        return this.categorySelected.ownerId;
      }
      return this.owner;
    },
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    // La config de Redsys (tokenizeCards) debe ser la del owner cuya
    // pasarela se usa (el de la categoría si el frame es de un agrupador),
    // no la del owner del frame. Se vuelve a pedir la configuración con el
    // owner de la categoría; si falla, se usa la del frame.
    async getRedsysTokenizeCards() {
      if (String(this.ownerId) === String(this.owner)) {
        return this.redsysConfiguration?.tokenizeCards;
      }
      try {
        const resp = await this.$store.dispatch(
          "configuration/getConfigurationByOwner",
          {
            type: this.$CONSTANTS.INTEGRATION.FRAME_WEB,
            ownerId: this.ownerId,
          },
        );
        const redsysConfig = resp.data && resp.data.configurationRedsysDto;
        if (redsysConfig && redsysConfig.tokenizeCards !== undefined) {
          return redsysConfig.tokenizeCards;
        }
      } catch (err) {
        // Fallback a la configuración del owner del frame
      }
      return this.redsysConfiguration?.tokenizeCards;
    },
    async setPaymentsUrl() {
      const tokenizeCards = await this.getRedsysTokenizeCards();
      const flow = tokenizeCards ? "cardList" : "directPay";
      const paymentsLangs = ["es", "en", "fr", "it", "de", "pt"];
      const rawLang = String(this.$PageUtils.getLanguageSplittedMinus() || "")
        .toLowerCase()
        .split(/[-_]/)[0];
      // "ca" -> "es": the payments modal was hardcoded to Spanish, so no regression; equivalence pending confirmation with product
      const normalizedLang = rawLang === "ca" ? "es" : rawLang;
      const lang = paymentsLangs.includes(normalizedLang)
        ? normalizedLang
        : "en";
      this.payments_url = `${process.env.VUE_APP_PAYMENTS_URL}/?flow=${flow}&token=${this.loginParameters.access_token}&userId=${this.userLoged.id}&ownerId=${this.ownerId}&lang=${lang}`;
      if (this.client) {
        this.payments_url += `&client=${this.client}`;
      }
      if (this.amount) {
        this.payments_url += `&amount=${this.amount}`;
      }
      const conceptValue = this.concept || this.$t("common.booking");
      this.payments_url += `&concept=${encodeURIComponent(conceptValue)}`;
    },

    onClickPayFromPayments() {
      this.$emit("pay");
    },

    setEventListener() {
      this.eventListener = (event) => {
        if (event.data === "onClickPayFromPayments") {
          this.onClickPayFromPayments();
        }
      };
      window.addEventListener("message", this.eventListener);
    },

    removeEventListener() {
      window.removeEventListener("message", this.eventListener);
      this.eventListener = undefined;
    },
  },
};
</script>

<style lang="scss">
.v-dialog--active {
  border-radius: 24px !important;
}
.v-dialog--fullscreen {
  height: 90% !important;
  bottom: 0 !important;
  top: auto !important;
  border-top-left-radius: 24px !important;
  border-top-right-radius: 24px !important;
  border-bottom-left-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}
</style>
